import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/mock';
import { Quote, Star } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="py-20 md:py-28 bg-[#FAFBFC]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="badge-minimal mb-6">Testimonials</span>
          <h2 className="title-minimal mb-4">
            What Our <span className="title-accent">Clients</span> Say
          </h2>
          <p className="text-base text-[#4A4A5A] max-w-2xl mx-auto">
            Don't just take our word for it — hear from the organizations 
            that have trusted us with their cleanroom projects.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="card-minimal p-6 hover:border-[#1C4B8A]/30"
            >
              <div className="w-10 h-10 rounded-lg bg-[#1C4B8A]/10 flex items-center justify-center mb-5">
                <Quote className="w-5 h-5 text-[#1C4B8A]" />
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>

              <p className="text-sm text-[#4A4A5A] mb-5 leading-relaxed">
                "{testimonial.content}"
              </p>

              <span className="inline-block px-3 py-1 text-xs font-medium text-emerald-600 bg-emerald-50 rounded mb-5">
                {testimonial.highlight}
              </span>

              <div className="pt-4 border-t border-[#E5E7EB]">
                <div className="font-semibold text-[#1A1A2E]">{testimonial.role}</div>
                <div className="text-sm text-[#8A8A9A]">{testimonial.company}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
